import { DbaBox } from "@/components/dba/DbaBox.js";
import { SolgtComBox } from "@/components/dba/SolgtComBox.js";
import { FinnBox } from "@/components/finn/FinnBox.js";
import { NettbilBox } from "@/components/finn/NettbilBox.js";
import { PageNavigator, PageNumber } from "@/components/PageNavigator.js";
import pulse from "@finn-no/pulse-sdk";
import { useConfig } from "@nmp-js/huck/client";
import React, { useState } from "react";
import type { Config } from "../../types.js";

export const LandingPage: React.FC = () => {
	const [activeBox, setActiveBox] = useState(PageNumber.ONE);

	interface ScrollEvent extends React.UIEvent<HTMLDivElement> {
		target: HTMLDivElement & EventTarget;
	}

	const handleScroll = (e: ScrollEvent): void => {
		const scrollLeft = e.target.scrollLeft;
		const totalWidth = e.target.scrollWidth - e.target.clientWidth;

		if (scrollLeft < totalWidth / 2) {
			setActiveBox(PageNumber.ONE);
		} else {
			setActiveBox(PageNumber.TWO);
		}
	};

	const snapXStyle = {
		scrollSnapType: "x mandatory",
		overflowX: "auto",
	};

	const snapCenterStyle = {
		width: "80%",
		scrollSnapAlign: "center",
	};

	const config: Config = useConfig<Config>();
	const isFINN = config.brand?.toLowerCase() === "finn";

	const trackCurrentPage = () => {
		pulse.trackPageView({
			type: "View",
			intent: "Show",
			name: "View product description page",
			object: {
				type: "Page",
				pageType: "product_description",
				name: "Product description page",
			},
			vertical: {
				name: "mobility",
			},
		});
	};

	if (typeof window !== "undefined") trackCurrentPage();

	return (
		<main className="mb-64">
			<h1 className="my-16 md:my-32">{isFINN ? "Hvordan vil du selge bilen?" : "Hvordan vil du sælge din bil?"}</h1>
			{/* @ts-expect-error - `style` prop here seems to complain about a false negative */}
			<div className="flex flex-row md:space-y-0 space-x-10 md:space-x-16" onScroll={handleScroll} style={snapXStyle}>
				<div className="shrink-0 md:shrink md:min-w-0 md:max-w-1/2" style={snapCenterStyle}>
					{isFINN ? <FinnBox /> : <DbaBox />}
				</div>
				<div className="shrink-0 md:shrink md:min-w-0 md:max-w-1/2" style={snapCenterStyle}>
					{isFINN ? <NettbilBox /> : <SolgtComBox />}
				</div>
			</div>
			<div id="page-navigator" className="md:hidden mt-24 flex justify-center">
				<PageNavigator activeBox={activeBox} />
			</div>
		</main>
	);
};
